import ElstrIo from "../ElstrIo";

interface AuthParameters {
  username: string;
  password: string;
  enterpriseApplication: string;
}

interface CreateParameters {
  username: string;
  password: string;
}

const className = "ELSTR_AuthServer";

export function auth(username: string, password: string, enterpriseApplication = "") {
  return ElstrUserService.auth(username, password, enterpriseApplication);
}

export function logout() {
  return ElstrUserService.logout();
}

export default class ElstrUserService {
  /**
   * Service method to handle auth request
   * If user can be authenticated, save user into session
   *
   * @param username
   * @param password
   * @param enterpriseApplication
   * @return Json Object
   */
  static async auth(username, password, enterpriseApplication): Promise<any> {
    try {
      return await ElstrIo.requestJsonRpc<AuthParameters, any>(className, "auth", {
        username,
        password,
        enterpriseApplication,
      });
    } catch (e) {
      return new Error(String(e));
    }
  }

  /**
   * Service method to handle sso request
   * If user can be authenticated, save user into session
   *
   * @return Json Object
   */
  static async sso(): Promise<any> {
    try {
      return await ElstrIo.requestJsonRpc(className, "sso", {});
    } catch (e) {
      return new Error(String(e));
    }
  }

  /**
   * Service method to handle logout request
   *
   * @return Json Object
   */
  static async logout(): Promise<any> {
    try {
      return await ElstrIo.requestJsonRpc(className, "logout", {});
    } catch (e) {
      return new Error(String(e));
    }
  }

  /**
   * Service method to handle user creation
   * Creates a new user
   *
   * @return Json Object
   */
  static async create(username, password): Promise<any> {
    try {
      return await ElstrIo.requestJsonRpc<CreateParameters, any>(className, "create", {
        username,
        password,
      });
    } catch (e) {
      return new Error(String(e));
    }
  }

  /**
   * Checks the group membership of the bound user
   *
   * @return Json Object
   */
  static async checkGroupMembership(): Promise<any> {
    try {
      return await ElstrIo.requestJsonRpc(className, "checkGroupMembership", {});
    } catch (e) {
      return new Error(String(e));
    }
  }
}
